import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/HighlightOff";
//Limitless imports
import ClientContext from "@limitless/common/utils/client-context/ClientContext";
const SlideCloseIcon = ({
  classes,
  isMobileDevice,
  onClose,
  slide
}) => {
  if (!isMobileDevice && ClientContext._fabButtonStyle !== "hidden") {
    return null;
  }
  const {
    closeIconColor,
    closeIconBackgroundColor,
    contrastColour
  } = slide;
  const iconColor = closeIconColor || contrastColour;
  const backgroundColor = closeIconBackgroundColor || "transparent";
  return /*#__PURE__*/React.createElement(IconButton, {
    style: {
      backgroundColor
    },
    className: classes.icon,
    component: "div",
    onClick: onClose,
    disableTouchRipple: true,
    size: "large"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    style: {
      color: iconColor
    }
  }));
};
const styles = {
  icon: {
    position: "absolute",
    right: 0,
    top: 0,
    padding: 8,
    margin: 8,
    borderRadius: "50%"
  }
};
export default withStyles(styles)(SlideCloseIcon);
SlideCloseIcon.propTypes = {
  classes: PropTypes.object.isRequired,
  slide: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  isMobileDevice: PropTypes.bool.isRequired
};